export const OFFER_FINANCIAL_SERVICES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialServicesUpdated";
export const OFFER_FINANCIAL_SERVICES_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialServicesComputed";
export const OFFER_FINANCIAL_SERVICES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialServicesInvalidated";
